import React from 'react';
import { ScrollView, View } from 'react-native';

import { Dialog, Heading, Text } from '../../components';
import { useThemedStyles } from '../../hooks/useThemedStyles';
import { Counter, SecondaryButton } from '../../design/components';

import { createPickListDetailStyles } from './PickListDetail.styles';

// Per-product list of picked quantities excluded from the tub weight.
const PickListTubWeightExclusionsDialog = ({
	isOpen,
	onClose,
	summaries,
	loading,
	onSetExcludedQuantity,
	onEdit,
}) => {
	const styles = useThemedStyles(createPickListDetailStyles);

	return (
		<Dialog
			isOpen={isOpen}
			onClose={onClose}
		>
			<View style={styles.dialogContent}>
				<Heading
					heading="Tub weight exclusions"
					subHeading="Exclude picked quantities from tub-weight calculations."
				/>
				<ScrollView style={styles.dialogList}>
					{
						summaries.length === 0 && (
							<Text style={styles.dialogEmpty}>
								No picked products available.
							</Text>
						)
					}
					{
						summaries.map(summary => (
							<View key={summary.productId} style={styles.dialogRow}>
								<Text style={styles.dialogRowTitle}>
									{summary.productName}
								</Text>
								<View style={styles.dialogRowControls}>
									<Text style={styles.dialogRowSubTitle}>
										{summary.excludedQuantity}/{summary.pickedQuantity} excluded
									</Text>
									<Counter
										value={summary.excludedQuantity}
										min={0}
										max={summary.pickedQuantity}
										disabled={loading}
										onChange={excludedQuantity => onSetExcludedQuantity({
											productId: summary.productId,
											excludedQuantity,
										})}
									/>
									<SecondaryButton
										label="Edit"
										disabled={loading}
										onPress={() => onEdit(summary.productId)}
									/>
								</View>
							</View>
						))
					}
				</ScrollView>
			</View>
		</Dialog>
	);
};

export default PickListTubWeightExclusionsDialog;
